var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as phoneValidator from "libphonenumber-js";
import { mapGetters } from "vuex";
import { ACCOUNT } from "@/stores/defs";
var phoneValidatorMixin = {
    computed: __assign({}, mapGetters({
        customer: ACCOUNT.GET_CUSTOMER
    }), { liveValidate: function () {
            // give user ability to delete area code
            var phoneLength = this.phone ? this.phone.replace(/\D/g, "").length : 0;
            if (this.phone && 3 < phoneLength) {
                this.asYouType.reset();
                this.asYouType.country = "US";
                this.phone = this.asYouType.input(this.phone.toString());
                return phoneValidator.isValidNumber(this.phone, "US");
            }
            else {
                return false;
            }
        } }),
    data: function () {
        return {
            asYouType: new phoneValidator.AsYouType("US"),
            phone: null,
        };
    },
    mounted: function () {
        if (this.customer && this.customer.phone) {
            this.phone = this.customer.phone;
        }
    },
    methods: {
        formatPhone: function (phone) {
            return (phone) ? new phoneValidator.AsYouType('US').input(phone) : "";
        }
    }
};
export default phoneValidatorMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/phoneValidatorMixin.ts
// module id = X9ha
// module chunks = 18